// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39iHP","tabsBox":"styles_tabsBox__1p5eB","createButton":"styles_createButton__14BRi"};